import React from "react";
import MapComponent from "./components/MapComponent";
import TileTransformer from "./components/tileTransformer";

function App() {
  // Initialize the tile transformer
  window.tileTransformer = new TileTransformer();

  return (
    <div style={{ position: "relative", height: "100vh" }}>
      <MapComponent />
    </div>
  );
}

export default App;
